import { skipToken, useQuery } from '@tanstack/react-query';

import { gatewayProductApi } from './gateway-product-api';
import type { ProductRequestParams } from './product-api';
import { productKeys } from './product-keys';

export const useProduct = (
  params: ProductRequestParams,
  options?: {
    disable?: boolean;
  }
) => {
  const queryResult = useQuery({
    queryKey: productKeys.byId(params.productId),
    queryFn: options?.disable
      ? skipToken
      : async () => gatewayProductApi.getProductById(params),
  });

  return queryResult;
};
